// extracted by mini-css-extract-plugin
export default {"card":"Card_card__DLTdm","appear":"Card_appear__m1agH","cardTextBody":"Card_cardTextBody__hHk3r","cardText":"Card_cardText__iu2ck"};